import { ClockIcon } from '@heroicons/react/24/outline';
import { minutesToHours } from '@youshift/shared/utils';

export function ShowRestPeriod({ restPeriod }: { restPeriod: number }) {
  return (
    <div className="flex flex-row justify-center items-center gap-1 mx-1 pb-1">
      <ClockIcon className="h-3 w-3 text-gray-500" />
      <p className="text-gray-800 md:text-xs text-xxxs whitespace-nowrap">{`${minutesToHours(restPeriod)} h`}</p>
    </div>
  );
}
